<!-- Attachment details -->
<div class="existing-attachment-body">
  <div class="existing-attachment-caption">{{ getCaption() | xsI18n }}</div>

  <div class="existing-attachment-header">
    <span
      class="existing-uploaded-by sa-ellipsis-text"
      [matTooltip]="parentActivity?.createdBy"
      matTooltipPosition="above"
      matTooltipClass="assist-mat-tooltip"
      [matTooltipDisabled]="parentActivity?.createdBy?.length < 15"
      [matTooltipShowDelay]="500"
      >{{ displayInformation?.activityProcurementCaption | xsI18n : parentActivity?.createdBy || '' }}</span
    >
    <div class="existing-uploaded-pipe">
      <span class="subtext-gray">|</span>
    </div>
    <div class="existing-uploaded-date">
      <xs-updating-time [hidespan]="true" [time]="displayInformation?.creationDate"></xs-updating-time>
    </div>

    <div *ngIf="canDelete" class="delete-attachment-button condensed association-no-right-padding top-padding-xxxs">
      <div [sotiPopupTriggerFor]="popupDelete" class="icon-spacing action">
        <div 
          class="xs-remove-btn"
          [soti-tooltip]="'xs_delete_label' | xsI18n"
          placement="bottom"></div>
      </div>
      <!--      xsight-headline5 caption-adjustment-->
      <soti-popup #popupDelete="sotiPopup" position="endBottom" [offsetY]="-10" [offsetX]="3">
        <div *sotiPopupContent class="popup-container">
          <div class="popup-title">{{ 'popover_Confirm_Title' | xsI18n }}</div>
          <div class="popup-body-text">
            <p>{{ 'attachment_DeleteConfirmation' | xsI18n }}</p>
          </div>
          <ins-modal-footer2 class="popup-footer">
            <button (click)="cancelDelete($event)" class="xs-btn btn-outline btn-space">
              {{ 'xs_cancel_label_short' | xsI18n }}
            </button>
            <button (click)="deleteAttachment()" class="xs-btn btn-primary">
              {{ 'xs_delete_label' | xsI18n }}
            </button>
          </ins-modal-footer2>
          <div class="popup-menu-beak"></div>
        </div>
      </soti-popup>
    </div>
  </div>

  <div class="existing-attachment-details existing-attachment-details-fix">
    <span class="existing-attachment-snapshot existing-attachment-snapshot-icon">
      <xs-attachment-media
        *ngIf="showAttachmentMedia()"
        [activity]="parentActivity"
        [isThumbnail]="true"
        [isMediaRefreshed]="isMediaReady"
      ></xs-attachment-media>
      <span
        *ngIf="showSnapshotThumbnail()"
        [class]="displayInformation?.activityThumbnail"
        class="existing-attachment-platform-thumbnail"
      ></span>
    </span>
    <div class="existing-attachment-details-body">
      <div class="existing-attachment-file-util">
        <div
          class="existing-attachment-file-name"
          [oneTime]="true"
          sa-ellipsis
          [fullText]="displayInformation?.activityCaption"
        ></div>

        <div class="existing-button-badge-download-ssp" *ngIf="showDownloadButton()" (click)="downloadFileFromSsp()">
          <span class="existing-attachment-file-util-download hd-icon icon-md hd-icon-download"></span>
        </div>
      </div>
      <div class="existing-attachment-file-util">
        <div class="existing-attachment-mcInstance-name" sa-ellipsis [fullText]="getDisplayInformation()"></div>
        <div class="existing-oval"></div>
        <div class="existing-link-button" *ngIf="showPreviewButton()">
          <a (click)="previewOrDownload()" class="btn btn-link btn-sm">
            <span class="subtext strong existing-link-button-text">{{ 'attachment_Preview_Caption' | xsI18n }}</span>
          </a>
        </div>

        <div class="existing-link-button" *ngIf="showDownloadButton()">
          <a (click)="downloadFile()" class="btn btn-link btn-sm">
            <span class="subtext strong existing-link-button-text">{{ 'attachment_Download_Caption' | xsI18n }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
